// extracted by mini-css-extract-plugin
module.exports = {"content":"OnboardingCompleted_content__6Z5e_","doneAnimation":"OnboardingCompleted_doneAnimation__wkeo7"};